module.exports = __webpack_public_path__ + "media/Video 134.c2737ea2.mp4";